import React from 'react';
import Popup from "reactjs-popup";
import Instructions from './instructions';

class Intro extends React.Component {

    render() {
        return <div className="intro">
                <div className="logo"><object data="img/logo.svg"></object></div>
                <p>Ingrese los montos que usted suele gastar al mes para conocer el efecto máximo de la reforma fiscal, a partir del 1.° de julio del 2019.</p>
                <Popup trigger={ () => <strong><a>VER INSTRUCCIONES</a></strong> } modal closeOnDocumentClick>
                    {close => (
                        <Instructions
                            close={close}
                            />
                    )}
                </Popup>
            </div>
    }

}

export default Intro;